// Hooks
import { usePrintPdf } from '@hooks/usePrintPdf';

/**
 * Interface for download action parameters
 */
export interface IDownloadActionParams {
    downloadAction?: () => void;
}

/**
 * Interface for default download parameters
 */
export interface IDefaultDownloadParams {
    title?: string;
    header?: string[][];
    body?: string[][];
}

/**
 * Custom hook for handling modal download actions
 * @param downloadAction - Optional custom download action
 * @param defaultParams - Optional default download parameters
 * @returns Object with handleDownload function
 */
export const useModalDownload = (
    downloadAction?: () => void,
    defaultParams?: IDefaultDownloadParams
): { handleDownload: () => void } => {
    const { downloadPDF } = usePrintPdf();

    const handleDownload = (): void => {
        if (downloadAction) {
            downloadAction();
        } else {
            // Default download action with customizable parameters
            downloadPDF({
                title: defaultParams?.title ?? 'Documento',
                header: defaultParams?.header ?? [['Campo', 'Valor']],
                body: defaultParams?.body ?? [['Ejemplo', 'Contenido']],
            });
        }
    };

    return {
        handleDownload,
    };
};

/**
 * Helper function to create a download handler with default parameters
 * @param downloadAction - Optional custom download action
 * @param defaultParams - Optional default download parameters
 * @returns Download handler function
 */
export const createDownloadHandler = (downloadAction?: () => void, defaultParams?: IDefaultDownloadParams): (() => void) => {
    const { downloadPDF } = usePrintPdf();

    return (): void => {
        if (downloadAction) {
            downloadAction();
        } else {
            // Default download action with customizable parameters
            downloadPDF({
                title: defaultParams?.title || 'Documento',
                header: defaultParams?.header || [['Campo', 'Valor']],
                body: defaultParams?.body || [['Ejemplo', 'Contenido']],
            });
        }
    };
};
